module.exports = __webpack_public_path__ + "static/media/RightBridgeFemale.64ce40ac.svg";